export default "__VITE_ASSET__Bt$dv5D7__"